import { Card } from 'components/Card';
import { DelayedSpinner } from 'components/Spinner';
import { useAuth } from 'contexts/auth-context';
import { roleToNumber } from 'src/app/auth/roles.client';
import { InternalRole } from '../../../auth/endpoints/MeEndpoint.types';

import { useAllGeneralSettings } from '../../all-settings-context';
import { useCarrierInformationDocuments } from '../../models';
import { CarrierTermsSection } from './components/CarrierTermsSection';
import { DieselSurchargeSection } from './components/DieselSurchargeSection';
import { DocumentCard } from './components/DocumentCard';
import { ExactAccountsImportSection } from './components/ExactAccountsImportSection';
import { SelfBillingDiscountSection } from './components/SelfBillingDiscountSection';
import { TruckDocumentReminderSection } from './components/TruckDocumentReminderSection';

export const CarrierInformationSettingsPage = () => {
  const { settings, refreshData } = useAllGeneralSettings();
  const { me } = useAuth();
  const isAdmin = roleToNumber(me.role) >= roleToNumber(InternalRole.InternalAdmin);
  const { data: documents, isLoading, mutate: refetchDocuments } = useCarrierInformationDocuments();

  const refresh = () => {
    refetchDocuments();
  };

  return (
    <div className="grid gap-4">
      <DieselSurchargeSection currentPercentage={settings.dieselSurchargePercentage} onSaved={refreshData} />

      <SelfBillingDiscountSection
        currentPercentage={settings.selfBillingCashDiscountPercentage ?? 2.5}
        onSaved={refreshData}
      />

      <TruckDocumentReminderSection />

      <CarrierTermsSection />

      {isAdmin && <ExactAccountsImportSection />}

      <Card title="Vervoerder informatie documenten">
        {isLoading ? (
          <DelayedSpinner />
        ) : (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            <DocumentCard mode="upload" onUploadSuccess={refresh} />

            {documents?.map((doc) => (
              <DocumentCard
                key={doc.id}
                mode="existing"
                document={{
                  id: doc.document.id,
                  name: doc.name || doc.document.name,
                  hash: doc.document.hash,
                  createdAt: doc.createdAt,
                }}
                attachmentId={doc.id}
                onDeleteSuccess={refresh}
                onRenameSuccess={refresh}
              />
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};
